var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "login"
  }, [_c("main", {
    staticClass: "login__main area"
  }, [_vm.isRegister ? _c("register-card", {
    on: {
      "toggle-register": _vm.handleToggle
    }
  }) : _c("login-card", {
    on: {
      "toggle-register": _vm.handleToggle
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };